import React from 'react'
import AlertIcon from '../../images/alert.svg'
import NotFoundIcon from '../../images/not-found.svg'
import { OnlinepbxButtonLink } from '@onpbx/onlinepbx-components'

export const PageNotFound: React.FC = () => {
  return (
    <div className='onlinepbx__page__not__found'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center onlinepbx__page__not__found__header'>
            <AlertIcon className='onlinepbx__page__not__found__alert' /> Страница не найдена
          </h2>
          <div className='onlinepbx__page__not__found__text'>
            Страница, на которую вы хотели перейти, не найдена. Возможно, введен некорректный адрес или страница была удалена.
            <div className='onlinepbx__page__not__found__btn'>
              <OnlinepbxButtonLink text='Вернуться на главную' href='/' />
            </div>
          </div>
          <div className='onlinepbx__page__not__found__block'>
            <div className='onlinepbx__page__not__found__content'>
              <NotFoundIcon className='onlinepbx__page__not__found__icon' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound
